import type { CmsWorkspaceShellModel } from '../contracts/server-model';

export const WORKSPACE_PREVIEW_MASONRY_CLASS =
  'cms-block-workspace-workspace-1-workspace-showcase-layout__workspacePreviewMasonry';
export const WORKSPACE_PREVIEW_MASONRY_COLUMN_CLASS =
  'cms-block-workspace-workspace-1-workspace-showcase-layout__workspacePreviewMasonryColumn';
export const WORKSPACE_PREVIEW_MASONRY_ITEM_CLASS =
  'cms-block-workspace-workspace-1-workspace-showcase-layout__workspacePreviewMasonryItem';
export const WORKSPACE_PREVIEW_MASONRY_WRAP_CLASS =
  'cms-block-workspace-workspace-1-workspace-showcase-layout__workspacePreviewMasonryWrap';
export const WORKSPACE_PREVIEW_MASONRY_SINGLE_CLASS =
  'cms-block-workspace-workspace-1-workspace-showcase-layout__workspacePreviewMasonryWrapSingle';

export type WorkspacePreviewImage =
  CmsWorkspaceShellModel['hero']['previewImages'][number];

export function resolveWorkspacePreviewAspectRatio(
  image: WorkspacePreviewImage
) {
  return `${image.dimensions.width} / ${image.dimensions.height}`;
}

function resolveWorkspacePreviewHeightRatio(image: WorkspacePreviewImage) {
  return image.dimensions.height / image.dimensions.width;
}

export function distributeWorkspacePreviewImages<
  TImage extends WorkspacePreviewImage,
>(images: readonly TImage[], columnCount: number) {
  const columns = Array.from({ length: columnCount }, () => ({
    estimatedHeight: 0,
    images: [] as TImage[],
  }));

  for (const image of images) {
    const target = columns.reduce((shortest, column) =>
      column.estimatedHeight < shortest.estimatedHeight ? column : shortest
    );
    target.images.push(image);
    target.estimatedHeight += resolveWorkspacePreviewHeightRatio(image);
  }

  return columns.map((column) => column.images);
}

export function shuffleWorkspacePreviewImages<TImage>(
  images: readonly TImage[],
  random: () => number = Math.random
) {
  const shuffled = [...images];
  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const targetIndex = Math.floor(random() * (index + 1));
    [shuffled[index], shuffled[targetIndex]] = [
      shuffled[targetIndex]!,
      shuffled[index]!,
    ];
  }
  return shuffled;
}
